import {
  GET_SHOPPING,
  INSERT_SHOPPING,
  UPDATE_SHOPPING,
  DELETE_SHOPPING,
  TOGGLE_SHOPPING_STATUS,
  OPEN_SHOPPING_DIALOG,
  CLOSE_DIALOG,
} from "./shopping.type";

const initialState = {
  shopping: [],
  total: 0,
  dialog: false,
  dialogData: null,
};

const shoppingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHOPPING:
      return {
        ...state,
        shopping: action.payload.shopping,
        total: action.payload.total,
      };

    case INSERT_SHOPPING:
      return {
        ...state,
        shopping: [action.payload, ...state.shopping],
        total: state.total + 1,
      };

    case UPDATE_SHOPPING:
      return {
        ...state,
        shopping: state.shopping.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    case DELETE_SHOPPING:
      return {
        ...state,
        shopping: state.shopping.filter((item) => item._id !== action.payload),
        total: state.total - 1,
      };

    case TOGGLE_SHOPPING_STATUS:
      return {
        ...state,
        shopping: state.shopping.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    case OPEN_SHOPPING_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };

    case CLOSE_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default shoppingReducer;
